'use strict';

import AlertActionCreators from '../actions/AlertActionCreators';
import AlertTypes from '../constants/AlertTypes';
import UserStore from '../stores/UserStore';
import parseStampSegment from '../utils/parseStampSegment';
import { isMobile } from '../utils/Browser';

function getDraftComposeRedirectTarget(stampSegment, draft) {

  // Tricky edge cases to keep in mind:
  // * User visiting draft's compose but we don't know if user is author yet
  // * User visiting somebody else's stamp compose
  // * Anonymous visiting somebody's draft compose
  // etc

  const isAuthenticated = UserStore.isAuthenticated();
  const { isServerDraft, isStamp } = parseStampSegment(stampSegment);
  const isReady = Boolean(draft);

  // It is important that we figure out if access is forbidden
  // even if draft is not ready yet. Thus we can exit early in
  // willTransitionTo instead of mounting the editor.

  const isForbidden =
    !isAuthenticated ||
    isReady && !draft.canEdit;

  if (isForbidden) {
    if (isServerDraft) {
      // User is not owner, might have copied the wrong link.
      // If it's a server draft, redirect to preview instead.
      return ['draftPreview', { stampSegment }];
    } else if (isStamp) {
      // Probably "Edit Stamp" link but user logged out. Redirect to stamp.
      return ['feedStamp', { stampSegment }];
    } else {
      // "New Draft" link but we're not logged in. Go home.
      AlertActionCreators.showAlert(AlertTypes.NOT_FOUND, { hideOnRouteChange: false });
      return ['feed'];
    }
  }

  if (isMobile()) {
    // Editor is not available on mobile.
    // Only show the message if we know this is the author.

    if (!isReady) {
      // Wait for the draft to load
      return [];
    }

    if (draft.canEdit) {
      AlertActionCreators.showAlert(AlertTypes.EDITOR_DESKTOP_ONLY, { hideOnRouteChange: false });
    }

    if (isServerDraft) {
      // Try our best and redirect to the preview which works on mobile.
      return ['draftPreview', { stampSegment }];
    } else if (isStamp) {
      // It's an "Edit Stamp" link, show stamp.
      return ['feedStamp', { stampSegment }];
    } else {
      // Go home.
      return ['feed'];
    }
  }

  return [];
}

module.exports = getDraftComposeRedirectTarget;


/** WEBPACK FOOTER **
 ** ./utils/getDraftComposeRedirectTarget.js
 **/